import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppConfig } from '../app.config';

export const kioskBlockGuard: CanActivateFn = () => {
  if (AppConfig.Shared.isKiosk) {
    inject(Router).navigate(['/user'], { queryParams: { tab: 'home' } });
    return false;
  }
  return true;
};
